import { Button, cn } from '@spiaggeit/spit-ui'
import Cookies from 'js-cookie'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

import { languages } from '@/models/app'
import { I18N_COOKIE_KEY, I18N_QS_KEY } from '../../app/i18n'
import { Flags } from '../../assets/icons/flags'

function setLanguageCookie(language: string) {
  const splittedHostname = window.location.hostname.split('.')
  const cookieDomain =
    splittedHostname.length > 2
      ? `.${splittedHostname.slice(1).join('.')}`
      : window.location.hostname

  Cookies.set(I18N_COOKIE_KEY, language, {
    domain: cookieDomain,
  })
  // Old cart reads the language and sets it in a new cookie, so we need to set it here as well beacuse we don't hit the endpoint that sets the cookie
  Cookies.set('yb_booking_lang', language, {
    domain: cookieDomain,
  })
}

export const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    if (searchParams.get(I18N_QS_KEY)) {
      setLanguageCookie(searchParams.get(I18N_QS_KEY) as string)
    } else {
      setLanguageCookie(i18n.language)
    }
  }, [])

  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language)
    setLanguageCookie(language)
  }

  return (
    <div className="flex w-full flex-col gap-4">
      <p className="text-center font-bold">{t('kiosk.landing.language')}</p>

      <div className="grid grid-cols-2 gap-2">
        {languages.map((lang) => {
          const Flag = Flags[lang.toUpperCase() as keyof typeof Flags]
          const isActive = lang === i18n.language

          return (
            <Button
              className={cn(
                'rounded border-gray-400 px-4 py-2.5 text-xs text-black',
                {
                  'border-blue-500 text-white': isActive,
                }
              )}
              key={lang}
              onClick={() => changeLanguage(lang)}
              variant="outline"
              {...(isActive && {
                variant: 'solid',
              })}
            >
              <>
                <Flag className="flex-shrink-0" />

                {t(`languageSwitcher.${lang}`)}
              </>
            </Button>
          )
        })}
      </div>
    </div>
  )
}
